import React, {Component, Fragment} from 'react';
import {NavLink} from 'react-router-dom'

import {BASE_PATH} from "../../../../wpconfig";

class ResourceItem2 extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const record = this.props.record;
		//console.log(record)
		return (
			<div className="document-list-item">
				<NavLink to={BASE_PATH + "resource/?record_id=" + record.resource_id}
				         className="item-subject">{record.resource_title}</NavLink>
				{rmVars.isEditor &&
				<a href={rmVars.homeUrl + "?page=resource&record_id=" + record.resource_id}
				   target="_blank"
				   className="ml-2"><span className="editor-edit"></span></a>
				}
				<div className="font-size-14 color-lightblack">
					{record.scholar && record.scholar.map((item, index) => {
						return(
							<Fragment key={index}>
								<strong className="color-lightblue"> {item.author_name}</strong>
								<span className="color-lightblue">({item.dept_name ? item.dept_name : ''})
									{record.scholar.length - 1 > index && ','}
								</span>
							</Fragment>
						)
					})}
				</div>
				<div className="item-info">
					{record.journal_title &&
					<div className="info-cell"><strong>Source</strong> {record.journal_title}</div>
					}
					{record.publisher &&
					<div className="info-cell"><strong>Publisher</strong> {record.publisher}</div>
					}
					<div className="info-cell">
						{record.publish_year ? record.publish_year : ''}
						{record.volume ? (record.publish_year ? ', ' + record.volume : record.volume) : ''}
						{record.issue ? (record.volume ? '('+record.issue+')' : ', no.'+record.issue) : ''}
						{record.start_page && record.end_page ? ', pp. ' : (record.start_page || record.end_page ? ', pp.' : '') }
						{record.start_page ? record.start_page + '-' : '' }
						{record.end_page ? (record.start_page ? record.end_page : '-' + record.end_page) : '' }
					</div>
				</div>
				{(record.journal_ranking && record.journal_ranking.length > 0 || record.resource_count > 0 || record.registered_db) &&
				<div className="item-options">
					<div className="options-cell">
						<div className="badge-group">
							<div className="badge-group-inner">
								{record.journal_ranking && record.journal_ranking.map((item, index) => {
									let className = 'badge bg-lightpurple rounded-0';
									if (!item.percent || !item.name)
										return;
									item.name = item.name.toUpperCase()
									if (item.name === 'KCI')
										className = 'badge bg-lightgreen rounded-0';
									else if (item.name === 'SCOPUS')
										className = 'badge bg-lightorange rounded-0';
									return (
										<div key={index}
										     className={className}>{item.name} (Top {item.percent}%)</div>
									)
								})}
								{record.registered_db && record.registered_db.map((item, index) => {
									let className = 'badge bg-lightpurple';
									item = item.toUpperCase()
									if (item.includes('KCI'))
										className = 'badge bg-lightgreen';
									else if (item.includes('SCOPUS'))
										className = 'badge bg-lightorange';
									return (
										<div key={index} className={className}>{item}</div>
									)
								})}
							</div>
						</div>
					</div>
				</div>
				}
			</div>
		)
	}
}

export default ResourceItem2;

// Resources.propTypes = {
//     monitor_box_status: PropTypes.bool,
//     listStatus: PropTypes.array,
//     id: PropTypes.string,
//     companyStatus: PropTypes.string,
//     companyName: PropTypes.string,
//     address: PropTypes.string,
//     reportID: PropTypes.string,
//     isUserList: PropTypes.string,
//     createDate: PropTypes.string,
//     startDate: PropTypes.string,
//     endDate: PropTypes.string,
//     advertiserName: PropTypes.string,
//     advertiserPhone: PropTypes.string,
//     operatorPhone: PropTypes.string,
//     operatorName: PropTypes.string,
//     reportKeywords: PropTypes.array,
//     monitoringInfo: PropTypes.string,
// };
